import React from 'react';
import propTypes from 'prop-types';

import { PageWrapper } from '@components/pagewrapper/pagewrapper';

import Redeem from '@components/redeem/redeem';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { initNeoGatewayServer } from '@helpers/neogateway';
import withAuth from '@components/auth';
import { isWeb } from '@helpers/helper';

// TODO: add SEO
export const Promocode = ({ query, isDesktop }) => {
	let { promocode, autoload } = query;
	const isDarkMode = Boolean(Number(query?.dark_mode));

	if (promocode && typeof promocode !== 'string') {
		promocode = promocode[0];
	}

	return (
		<PageWrapper hideHeader={false} hideFooter={false}>
			<Redeem
				isDarkMode={isDarkMode}
				isMobile={!isDesktop}
				promocode={promocode}
				autoload={autoload}
				urlParams={query}
			/>
		</PageWrapper>
	);
};

export async function getServerSideProps(ctx: any) {
	const { pageProps } = await initNeoGatewayServer(ctx);
	const { req } = ctx;
	const isDesktop = isWeb(req.headers['user-agent']);
	return {
		props: {
			...pageProps,
			...(await serverSideTranslations(ctx.locale, ['common'])),
			query: ctx.query,
			isDesktop
		}
	};
}

Promocode.propTypes = {
	query: propTypes.any,
	isDesktop: propTypes.bool
};

export default withAuth(Promocode);
